import { render } from "./CatchResult.vue?vue&type=template&id=209c1c80&scoped=true"
import script from "./CatchResult.vue?vue&type=script&lang=js"
export * from "./CatchResult.vue?vue&type=script&lang=js"

import "./CatchResult.vue?vue&type=style&index=0&id=209c1c80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209c1c80"]])

export default __exports__